// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host ::ng-deep .custom-table {
  /* صف الإجمالي: خلفية خضراء عندما isSummaryRow === true */
}
:host ::ng-deep .custom-table tr.summary-row,
:host ::ng-deep .custom-table tr.summary-row:hover {
  background-color: #dcfce7 !important;
  /* green-100 */
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/table-account-statements/table-account-statements.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AACd;EAEE,yDAAA;AAAJ;AACI;;EAEE,oCAAA;EACA,cAAA;AACN","sourcesContent":[":host {\n  ::ng-deep .custom-table {\n\n    /* صف الإجمالي: خلفية خضراء عندما isSummaryRow === true */\n    tr.summary-row,\n    tr.summary-row:hover {\n      background-color: #dcfce7 !important;\n      /* green-100 */\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
